import { Box, FormGroup } from '@mui/material';
import TextWrapper from './useTextWrapper';
import { styled } from '@mui/system';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useField, useFormikContext } from 'formik';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';

const StyledDatePicker = styled(DatePicker)(({ theme }) => ({
	'& .MuiInputBase-root': {
		'& .MuiInputBase-input': {
			padding: '8.5px 14px',
		},
	},
}));

DatePickerWrapper.propTypes = {
	minDate: PropTypes.any,
	maxDate: PropTypes.any,
	defaultMinDate: PropTypes.bool,
	defaultMaxDate: PropTypes.bool,
	setCurrentDateAsDefault: PropTypes.bool,
};

export default function DatePickerWrapper({
	minDate = null,
	maxDate = null,
	defaultMinDate = false,
	defaultMaxDate = false,
	disabled = false,
	setCurrentDateAsDefault = false,
	formGroupClass = '',
	format: displayFormat = 'dd/MM/yyyy',
	onChange,
	...props
}) {
	const [field, meta] = useField(props);
	const [defaultMinDateValue, setDefaultMinDateValue] = useState(new Date());
	const [defaultMaxDateValue, setDefaultMaxDateValue] = useState(new Date());
	let value = field.value;
	if (value && typeof value == 'string') {
		value = Date.parse(value);
	}
	const { setFieldValue } = useFormikContext();

	useEffect(() => {
		setDefaultMaxDateValue(new Date());
		setDefaultMinDateValue(new Date());
		if (setCurrentDateAsDefault) {
			setFieldValue(field.name, new Date());
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [defaultMinDate, defaultMaxDate, setCurrentDateAsDefault]);
	return (
		<FormGroup className={formGroupClass}>
			<Box className="flex flex-col items-start w-full custom-date-picker">
				<Box className="flex flex-0 items-center !relative">
					<TextWrapper
						classList='!text-[11px]'
						type="caption"
						text={props?.label}></TextWrapper>
					{meta.error && meta.touched && props?.label ? (
						<span className="!text-red-500 !absolute !right-[-6px] !top-[-3px]">
							*
						</span>
					) : null}
				</Box>
			</Box>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<StyledDatePicker
					disabled={disabled}
					minDate={
						minDate ? minDate : defaultMinDate ? defaultMinDateValue : null
					}
					maxDate={
						maxDate ? maxDate : defaultMaxDate ? defaultMaxDateValue : null
					}
					format={displayFormat}
					className={meta.error && meta.touched ? 'date-picker-error' : ''}
					onChange={(val) => {
						const isValidDate = val && !isNaN(new Date(val).getTime());
						const formatted = isValidDate ? format(new Date(val), 'yyyy-MM-dd') : '';
						setFieldValue(field.name, formatted);
						onChange && onChange(formatted);
					}}
					slotProps={{
						textField: {
							helperText: (
								<span className="text-red-500">
									{meta.error && meta.touched ? meta.error : ''}
								</span>
							),
						},
					}}
					value={value}></StyledDatePicker>
			</LocalizationProvider>
		</FormGroup>
	);
}
